export const IsMobile = (): boolean => {
  if (typeof window === 'undefined') return false;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 576;
};

export const IsMobileSize = (): boolean => {
  if (typeof window === 'undefined') return false;

  return window.innerWidth < 576;
};

export const isIos = (): boolean => {
  if (typeof window === 'undefined') return false;

  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const IsMacOs = () => {
  if (typeof window === 'undefined') return false;

  return /Macintosh|Mac OS X/.test(navigator.userAgent);
};

export const IsAndroid = () => {
  if (typeof window === 'undefined') return false;

  return /Android/.test(navigator.userAgent);
};
